// Module
var code = "<datasource-http-settings-next on-change=\"onChange\" datasourceconfig=\"current\" showaccessoptions=\"showAccessOption\" defaulturl=\"suggestUrl\" showforwardoauthidentityoption=\"showForwardOAuthIdentityOption\">\n";
// Exports
var _module_exports =code;;
var path = 'public/app/angular/partials/http_settings_next.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;